import { Button, Col, Form, InputNumber, Row, Spin, Modal } from 'antd';
import React, { useState, useEffect } from 'react';
import CountUp from 'react-countup';
import { RouteComponentProps } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getSoldeCompteScolarite, rechargeBySchoolAccount as requestRechargeBySchoolAccount } from './appro.reducer';
import { getEcole } from '../ecole/ecole.reducer';

export const TransfertCompteSalaire = (props: RouteComponentProps<{ ecoleid: string; anneeScolaireId: string }>) => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const loadingVirement = useAppSelector(state => state.virement.loading);
  const approvisonnement = useAppSelector(state => state.approvisonnement.entity);
  const soldeScolarite = useAppSelector(state => state.approvisonnement.solde);
  const loading = useAppSelector(state => state.approvisonnement.loading);
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    dispatch(getEcole(props.match.params.ecoleid));
    dispatch(getSoldeCompteScolarite(props.match.params.ecoleid));
  }, [dispatch, props.match.params.ecoleid]);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    const values = form.getFieldsValue();
    const entity = {
      ...approvisonnement,
      ...values,
      ecoleId: props.match.params.ecoleid,
      anneeScolaireId: props.match.params.anneeScolaireId,
    };

    dispatch(requestRechargeBySchoolAccount(entity)).then(() => {
      form.resetFields();
      setIsModalVisible(false);
      props.history.push(`/approvisonnements/${props.match.params.ecoleid}/${props.match.params.anneeScolaireId}`);
    });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleSubmit = () => {
    form.validateFields().then(values => {
      showModal();
    });
  };

  return (
    <div>
      <div style={{ textAlign: 'center', marginTop: '10px' }}>
        <h4 style={{ fontWeight: 'bold' }}>Transfert des Fonds</h4>
        <p style={{ fontSize: '18px', marginTop: '20px' }}>
          Si vous souhaitez approvisonner le compte salaire depuis le compte de scolarité, <br />
          veuillez renseigner le formulaire ci-dessous :
        </p>
      </div>

      <Row className="p-2 justify-content-center" style={{ marginBottom: '20px' }}>
        {loadingVirement ? (
          <Spin tip="Chargement..." />
        ) : (
          <h4 style={{ color: '000A', marginTop: '30px', fontWeight: 'bold' }}>
            {' '}
            Solde compte Scolarité:{' '}
            <strong>
              <CountUp end={soldeScolarite} separator="." /> FCFA
            </strong>
          </h4>
        )}
      </Row>

      <Row justify="center" style={{ marginBottom: '20px' }}>
        <Col xs={24} sm={20} md={16} lg={12}>
          <Form name="approvisonnement" onFinish={handleSubmit} form={form} layout="vertical">
            <Form.Item
              name="montant"
              label={<span>Montant</span>}
              rules={[
                {
                  type: 'number',
                  min: 0,
                  max: soldeScolarite,
                  message: `Solde insuffisant. Le solde de votre compte est ${soldeScolarite} FCFA`,
                },
                { required: true, message: 'Veuillez saisir le montant' },
              ]}
              style={{ marginBottom: '20px' }}
            >
              <InputNumber
                placeholder="CFA"
                controls={false}
                min={0}
                style={{
                  width: '100%',
                  borderRadius: '10px',
                  padding: '0 10px',
                  height: '50px',
                  lineHeight: '45px',
                }}
                className="form-control"
              />
            </Form.Item>

            <Form.Item
              name="confirmMontant"
              label={<span>Confirmez le montant</span>}
              dependencies={['montant']}
              rules={[
                {
                  validator(_, value) {
                    if (!value || value === form.getFieldValue('montant')) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Le montant saisi et le montant de confirmation ne correspondent pas.'));
                  },
                },
                { required: true, type: 'number', min: 0, message: 'Veuillez confirmer le montant' },
              ]}
              style={{ marginBottom: '20px' }}
            >
              <InputNumber
                placeholder="CFA"
                min={0}
                style={{
                  width: '100%',
                  borderRadius: '8px',
                  padding: '0 10px',
                  height: '45px',
                  lineHeight: '40px',
                }}
                className="form-control"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                style={{
                  backgroundColor: '#F28E19',
                  color: '#fff',
                  borderRadius: '8px',
                  border: '1px solid #F28E19',
                  width: '100%',
                  height: '45px',
                }}
              >
                {loading ? (
                  <Spin />
                ) : (
                  <span
                    style={{
                      fontWeight: '600',
                      fontSize: '18px',
                    }}
                  >
                    Valider
                  </span>
                )}
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>

      <Modal title="Confirmation" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
        <p>Êtes-vous sûr de vouloir soumettre cette demande d&apos;approvisionnement ?</p>
      </Modal>
    </div>
  );
};

export default TransfertCompteSalaire;
